const defaultView = {
  id: 'all-customers',
};

const initialState = {
  view: defaultView,
};

export const customersView = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export { namespace } from './customers.view.reducer.metadata';
